import React from 'react';
import FadeSlideIn from "../../common/FadeSlideIn";
import landingBonusesHeader from "../../../resources/landingBonusesHeader.png";
import RollRewards from "./rewards/RollRewards";
import LuxdropRewards from "./rewards/LuxdropRewards";
import HypedropRewards from "./rewards/HypedropRewards";
import StakeRewards from "./rewards/StakeRewards";
import BigRewards from "./rewards/BigRewards";

const LandingBonuses = () => {
    return (<FadeSlideIn>
        <div className="landingBonuses">
            <div className="container">

                <div className="landingBonusesOuter">

                    <p className={'headerMaintext'}>START CLAIMING</p>
                    <img src={landingBonusesHeader} alt=""/>
                    <p className={'headerSubtext'}>Follow these steps to gain eligibility and instant access to rewards!</p>

                    <div className="landingBonusesWrapper">

                        <LuxdropRewards />

                        <StakeRewards />

                        <RollRewards />

                        <HypedropRewards />

                        <BigRewards />

                    </div>
                </div>

            </div>
        </div>
    </FadeSlideIn>);
}
export default LandingBonuses;